/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaFreightChargesViewProps } from './citta-freight-charges';

const CittaFreightChargesView: React.FC<ICittaFreightChargesViewProps> = props => {
    const { ProductFreightContainer, productFreightAmount, productFreightMessage, productFreightCalculate, productFreightUpdate,
        productFreightModel, productNoFreight, freightAttribute, ProductFreightAttribute, ProductFreightAttributeModal, ProductNoFreightAttribute, freightResponseCheck } = props;
    if (freightAttribute) {
        return (
            <Module {...ProductFreightContainer}>
                {freightResponseCheck ?
                    <Node {...ProductFreightAttribute}>
                        {productFreightAmount}
                        {productFreightMessage}
                        {productFreightUpdate}
                    </Node> :
                    <Node {...ProductFreightAttribute}>
                        {productFreightCalculate}
                    </Node>}
                <Node {...ProductFreightAttributeModal}>
                    {productFreightModel}
                </Node>
            </Module>
        );
    } else {
        return (
            <Node {...ProductNoFreightAttribute}>
                {productNoFreight}
            </Node>
        );
    }
};

export default CittaFreightChargesView;
